import { useState, useEffect } from "react";
import "../../ConsignmentNote.css";
import axios from "axios";
import Global from "../../APIConfig";
import AuthUser from "../../AuthUser";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Barcode from "../../Barcode";

function PrsPrint() {
  let navigate = useNavigate();
  const { slipno } = useParams();
  const { headers1, headers2, logout } = AuthUser();
  const [pickupdata, setPickupdata] = useState([]);
  const [companyDetails, setCompanyDetails] = useState("");
  const [routecode, setRoutecode] = useState("No");
  const [hubname, setHubname] = useState("");
  const [messenger_name, setMessenger_name] = useState("");
  const [vehicle_number, setVehicle_number] = useState("");
  const [printlogo, setPrintlogo] = useState("");
  const [gDefaultCurrency, setGDefaultCurrency] = useState("$");
  const [pickupdate, setPickupdate] = useState("");
      const location = useLocation();
      const [isReadyToPrint, setIsReadyToPrint] = useState(false);


         useEffect(() => {
          if (location.state?.triggerPrint) {
            // Wait for render completion
            setIsReadyToPrint(true);
          }
        }, [location.state]);
      
        useEffect(() => {
        if (isReadyToPrint) {
          const timeout = setTimeout(() => {
               alert(
              "Before printing:\n\n" +
              "- Set layout to Landscape\n" +
              "- Set paper size to A4\n" +
              "- Set margins to Default\n" +
              "Then press Print."
            );
            window.print();
      
            window.onafterprint = () => {
              navigate(-1); // or any path you want
            };
          }, 1000);
      
          return () => clearTimeout(timeout);
        }
      }, [isReadyToPrint]);

  useEffect(() => {
    GetShipmentdata();
  }, []);
  const GetShipmentdata = () => {
    axios({
      method: "post",
      url: Global.baseUrl + "PrintPickup",
      headers: headers1,
      data: {
        drs_unique_id: slipno,
      },
    })
      .then(function (response) {
        if (response.data.status == 200) {
          var data = response.data.value;
          setPickupdata(data);
          setCompanyDetails(data.companyDetails);
          setGDefaultCurrency(data.gDefaultCurrency);
          setHubname(response.data.hub_name);
          setMessenger_name(response.data.messenger_name);
          setVehicle_number(response.data.vehicle_number);
          setPrintlogo(response.data.printlogo);
          setRoutecode(data[0].routecode);
          setPickupdate(data[0].drs_date);
        }
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          toast.error(error.response.statusText);
          logout();
          navigate("/");
          window.location.reload();
        }
        // console.log(error);
      });
  };
  return (
    <div className=" container-fluid mt-3">
      <div className="row justify-content-between">
        <div className="col-12 col-md-3">
          <img src={`${Global.logoUrl}${printlogo}`} className="img-fluid" />
        </div>
        <div className="col-12 col-md text-center">
          <h2>Pickup Run Sheet</h2>
          <div className="d-flex justify-content-center">
            <div className="p-1">Pickup Date: {pickupdate}</div>
            {/* <div className="p-1">HUB Code: MUMB01</div> */}
            {/* <div className="p-1">Route Code: {routecode}</div> */}
          </div>
        </div>
        <div className="col-12 col-md-3 text-end">
          <Barcode value={slipno} />
        </div>
      </div>
      <div className="row mt-3 justify-content-between">
        <div className="col-12 col-md-4">
          Pickup Hub Name: {hubname} <br />
          Route Code: {routecode}
        </div>
        <div className="col-12 col-md-4 text-end">
          Pickup Person Name: {messenger_name}
          <br />
          Vehicle Reg No: {vehicle_number}
        </div>
      </div>

      <div
        className="row mt-3 justify-content-between table-responsive-sm"
        style={{ overflowX: "auto" }}
      >
        <table className="table table-bordered border-dark border-2">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>AWB #</th>
              <th>Customer Detail</th>
              <th>Pieces</th>
              <th>weight</th>
              <th>NDR Reason</th>
              <th>Receiver Signature</th>
            </tr>
          </thead>
          <tbody>
            {pickupdata.map((pick, i) => {
              return (
                <tr>
                  <td>1</td>
                  <td className="text-center">
                    <Barcode value={Number(pick.slip_no)} />
                  </td>
                  <td>
                    <h6>{pick.sender_name}</h6>
                    <p>
                      {pick.sender_address}, {pick.city}, {pick.state},{" "}
                      {pick.country}
                    </p>
                    <p>Mob: {pick.sender_phone}</p>
                    {pick.booking_mode === "COD" && (
                      <>
                        <h6>Mode: {pick.booking_mode}</h6>
                        <h4>
                          Price: {gDefaultCurrency}
                          {pick.total_amt}
                        </h4>
                      </>
                    )}
                  </td>
                  <td>{pick.pieces}</td>
                  <td>{pick.volumetric_weight}</td>
                  <td>
                    <p>&#9634; Not avaiable</p>
                    <p>&#9634; Door Locked</p>
                    <p>&#9634; Strike</p>
                    <p>&#9634; Road blocked</p>
                    <p>&#9634; Weather conditions</p>
                    <p>&#9634; Unpaid transpotation fees</p>
                  </td>
                  <td>
                    <table>
                      <tr>
                        <td>Name:</td>
                        <td>____________________________</td>
                      </tr>
                      <tr>
                        <td>Relation:</td>
                        <td>____________________________</td>
                      </tr>
                      <tr>
                        <td>Phone No:</td>
                        <td>____________________________</td>
                      </tr>
                      <tr>
                        <td>Date:</td>
                        <td>____________________________</td>
                      </tr>
                      <tr>
                        <td>Timeo:</td>
                        <td>____________________________</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <hr />
      <div className="mt-3">
        <div className="row">
          <div className="col-12 col-md-6 text-center">
            <h6>Sender Signature</h6>
            <p>____________________________</p>
          </div>
          <div className="col-12 col-md-6 text-center">
            <h6>Driver Signature</h6>
            <p>____________________________</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrsPrint;
